import React from 'react'

import './index.scss'

export const Footer = () => (
  <footer className="footer">
    © Shinners, Built with{' '}
    <a href="https://github.com/JaeYeopHan/gatsby-starter-bee">
      Gatsby-starter-bee
    </a>
  </footer>
)
